/* RESPONSIBLE TEAM: team-fin-voice */

/**
 * Converts language code (e.g., 'en-US', 'fr-FR') to Unicode flag emoji
 * Uses regional indicator symbols (U+1F1E6 to U+1F1FF)
 */
export function getLanguageFlag(languageCode: string): string {
  let parts = languageCode.split('-');
  if (parts.length !== 2) {
    return '';
  }

  let countryCode = parts[1].toUpperCase();
  if (countryCode.length !== 2) {
    return '';
  }

  // Convert to regional indicator symbols
  let codePoints = countryCode.split('').map((char) => {
    let code = char.charCodeAt(0);
    if (code < 65 || code > 90) {
      return null;
    }
    return 0x1f1e6 + (code - 65);
  });

  if (codePoints.includes(null)) {
    return '';
  }
  return String.fromCodePoint(...(codePoints as number[]));
}
